export default __webpack_public_path__ + "static/media/232.10d244d3.svg";